import { Checkbox } from "@mantine/core";

const CheckBoxComp = ({
  label = "",
  checked,
  onChange,
  value,
  disabled = false,
  size = "sm",
  color = "blue",
  labelPosition = "right",
  ...rest
}) => {
  return (
    <Checkbox
      label={label}
      checked={checked}
      onChange={onChange}
      value={value}
      disabled={disabled}
      size={size}
      color={color}
      labelPosition={labelPosition}
      {...rest}
    />
  );
};

export default CheckBoxComp;
